import { DataCollection } from '@/data/types';
import { createContext } from 'react';

export interface RouterContextType {
	backKeys: Record<string, string> | undefined;
	url: URL;
	push: (href: string, doReplace?: boolean) => void;
	replace: (href: string) => void;
	go: (num: number) => void;
	isLoading: boolean;
	isError: boolean;
	data: DataCollection;
	keys: Record<string, string>;
}

export const RouterContext = createContext<RouterContextType>(null!);
